import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Images from "../Images";
import { FaCaretDown, FaCaretUp, FaRegStar } from "react-icons/fa";
import { IoShareSocialSharp } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import { addWistList, getWishlist, removeWishList } from "../Actions/v1/user";
import { formatNumber, isEmpty } from "../Actions/commonFunction";
import { toast } from "react-toastify";
import { setWishlist } from "../Redux/user.action";

function Coindetaildash({ coindetail, getcoin }) {
  const dispatch = useDispatch();
  const { account, wishlist } = useSelector((state) => state?.user);
  console.log("🚀 ~ Coindetaildash ~ account:", account, wishlist);

  const addFav = async () => {
    if (isEmpty(account)) {
      return toast.warn("Please Login");
    }
    let resp;
    //ADD Wishlist
    if ( isEmpty(wishlist) || !(wishlist?.coins ?? [])?.includes(coindetail?._id)) {
      resp = await addWistList({
        _id: account?._id,
        assetId: coindetail?._id,
        type: "coins",
      });
    } else {
      resp = await removeWishList({
        _id: account?._id,
        assetId: coindetail?._id,
        type: "coins",
      });
    }

    if (resp?.status) {
      let wishlist = await getWishlist({ _id: account?._id });
      dispatch(
        setWishlist({
          ...wishlist.data,
        })
      );
      getcoin();
      toast.success(resp?.message);
    }
  };

  return (
    <div className="maincoin  py-3 px-3">
      <div className="d-block d-sm-flex flex-wrap justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <img src={coindetail?.logo} className="cointop" alt="coin" />
          <h4 className="mb-0 d_white">{coindetail?.name && coindetail?.name?.length > 10 ? `${coindetail?.name?.slice(0,5)}...` : coindetail?.name }</h4>
          <p className="mb-0 d_white">{coindetail?.symbol}</p>
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="tooltip-top" className="custom-tooltip">
                Ranked 1st out of all 526 active cryptocurrencies listed on
                Edaface listing.
              </Tooltip>
            }
          >
            <p className="mb-0 hash rounded-4">#1</p>
          </OverlayTrigger>
        </div>
        <div className="d-flex align-items-center gap-2 mt-2 mt-sm-0">
          <p
            onClick={() => addFav()}
            className="mb-0 hash rounded-2 d-flex align-items-center gap-1"
          >
            <FaRegStar
              fill={`${
                wishlist?.coins?.includes(coindetail?._id) ? "gold" : ""
              }`}
            />{" "}
            {formatNumber(coindetail?.wishcount ?? 0)}
          </p>
          <p className="mb-0 hash rounded-2">
            <IoShareSocialSharp />
          </p>
        </div>
      </div>
      <h3 className="mt-3 d_white">${formatNumber(Number(coindetail?.usdPrice))}</h3>
      <p className="mb-0 tradeclr">
        {Number(coindetail?.percent?.current) >
        Number(coindetail?.percent?.last) ? (
          <FaCaretUp />
        ) : (
          <FaCaretDown />
        )}{" "}
        {coindetail?.tradevolume}%
      </p>
    </div>
  );
}

export default Coindetaildash;
